import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";

// Tipos de layout disponíveis
export type LayoutType = "app" | "auth" | "empty";

// Definição de qual layout usar para cada rota específica
const layoutMap: Record<string, LayoutType> = {
	"/": "empty",
	"/logout": "auth",
};

export function useLayout() {
	const route = useRoute();
	const authStore = useAuthStore();

	const currentLayout = computed((): LayoutType => {
		const routePath = route.path;

		// Primeiro, verificar se a rota tem um layout específico na metadata
		if (route.meta?.layout) {
			return route.meta.layout as LayoutType;
		}

		// Se a rota tem um layout específico definido no mapa
		if (layoutMap[routePath]) {
			return layoutMap[routePath];
		}

		// Se a rota requer autenticação e o usuário está logado, usar layout principal
		if (route.meta?.requiresAuth && authStore.isLoggedIn) {
			return "app";
		}

		// Para rotas públicas não mapeadas, usar layout vazio
		return "empty";
	});

	const layoutComponent = computed(() => {
		switch (currentLayout.value) {
			case "app":
				return "AppLayout";
			case "auth":
				return "AuthLayout";
			case "empty":
			default:
				return "EmptyLayout";
		}
	});

	return {
		currentLayout,
		layoutComponent,
	};
}
